import React, { FunctionComponent } from 'react';
import { ReactComponent as Tool } from '$/images/tool.svg';

interface NoInteractionProps {
  isEdit: boolean;
}

const NoInteraction: FunctionComponent<NoInteractionProps> = ({ isEdit }) => {
  if (!isEdit) return null;

  return (
    <div className='w-full'>
      <div className='bg-blue-1 flex flex-col items-center p-8 rounded-lg text-sm'>
        <p className='text-lg mb-5'>No interactions yet! 😟</p>
        <Tool className='mb-5' />
        <p className='text-left'>
          Drag the playhead tool and select an interaction to add it at a specific time in the
          video.
        </p>
      </div>
    </div>
  );
};

export default NoInteraction;
